import { useEffect, useState } from "react"
import { SocialAccountMapping } from "../../../helpers/interfaces"
import { FormEditMode } from "../../../helpers/constants"
import { createSocialAccountMapping, updateSocialAccountMapping } from "../../../apiServices/GTBMappingKeysApi"
import CustomDialog from "../../CustomDialog"
import { CustomTextField } from "../../../layouts/themes"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"


interface Props {
    setSocialAccountMapping:React.Dispatch<React.SetStateAction<SocialAccountMapping[]>>
    socialAccountMapping: SocialAccountMapping[]
    openSocialAccountMappingForm:boolean
    setFormEditMode:  React.Dispatch<React.SetStateAction<number>>
    setOpenSocialAccountMappingForm:React.Dispatch<React.SetStateAction<boolean>>
    socialAccountMappingToEdit:string
    socialAccountMappingEditMode:number
}
function CreateEditSAMapping(props: Props) {
    const [socialAccountMappingName, setSocialAccountMappingName] = useState<string>("");
    
    useEffect(() => {
        if (props.socialAccountMappingEditMode === FormEditMode.EDIT) {
            var samName = props.socialAccountMapping.find(e => e.id === props.socialAccountMappingToEdit)
            if (!samName) return
            setSocialAccountMappingName(samName.name)
           
        }
    }, [props.socialAccountMapping, props.socialAccountMappingEditMode, props.socialAccountMappingToEdit])

    function createNewSocialAccountMapping() {
        createSocialAccountMapping(socialAccountMappingName).then(_sam=> {
            props.setOpenSocialAccountMappingForm(false);
            props.setSocialAccountMapping(sam => [...sam, _sam])
            
        })
    }
    function updateNewSocialAccountMapping() {
        updateSocialAccountMapping(props.socialAccountMappingToEdit, socialAccountMappingName).then(result => {
            props.setOpenSocialAccountMappingForm(false);
            props.setSocialAccountMapping(tax => tax.map(a=> a.id === props.socialAccountMappingToEdit ? result: a))
           
        })
    }
    return (
        <>
        <CustomDialog dialogTitle={props.socialAccountMappingEditMode === FormEditMode.CREATE ? 'Add New Social Account Mapping ' : 'Update Social Account Mapping '} setOpenDialog={props.setOpenSocialAccountMappingForm} openDialog={props.openSocialAccountMappingForm}>
            <form>
                <div >
                    <label className='title-label'>Social Account Mapping  Name <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="Social Account Mapping  Name" value={socialAccountMappingName} onChange={(e) => setSocialAccountMappingName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={!socialAccountMappingName} variant="contained" color='secondary' onClick={props.socialAccountMappingEditMode === FormEditMode.CREATE ? createNewSocialAccountMapping : updateNewSocialAccountMapping} >
                        <Add />&nbsp; {props.socialAccountMappingEditMode === FormEditMode.CREATE ? 'Add New Social Account Mapping' : 'Update Social Account Mapping'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditSAMapping